import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "vue"

import type { CommonService } from "./service"

export type ListServicesResponseItem = CommonService

export type ListServicesFilter = {
  name?: string
  search?: string
}

export type ListServicesOrdering =
  | "createdAt"
  | "-createdAt"

export type ListServicesQuery = ListServicesFilter & {
  ordering?: ListServicesOrdering
}

export const listServices = async (
  query?: ListServicesQuery
) => {
  const { body } = await api.get<
    ListServicesResponseItem[]
  >("/services/services/", { query: query })
  return body
}

export const useServices = (
  query?: MaybeRef<ListServicesQuery | undefined>
) =>
  useQuery({
    queryKey: [SERVICES_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listServices(query_),
  })
